import { MouseEventHandler, ReactElement } from 'react'
import { ButtonBase, styled, Tooltip } from '@mui/material'
import { tokens } from 'ComponentLibrary'
import { Typography } from '../../text'
import { IconContext } from '@phosphor-icons/react'

export type ExportActionButtonProps = {
    label: string
    leftIcon?: ReactElement
    rightIcon?: ReactElement
    onClick: MouseEventHandler<HTMLButtonElement>
    disabled?: boolean
    tooltip?: string
}

export function ExportActionButton({ label, leftIcon, rightIcon, onClick, disabled, tooltip }: ExportActionButtonProps) {
    return (
        <Tooltip title={tooltip} placement="top" sx={{ zIndex: 2000 }}>
            <span>
                <StyledExportButton onClick={onClick} disableRipple disabled={disabled}>
                    {leftIcon && (
                        <IconContext.Provider
                            value={{
                                size: tokens.SizingIconS,
                                weight: 'bold',
                                color: disabled ? tokens.ColorIconDisabled : tokens.ColorIconBoldest,
                            }}
                        >
                            {leftIcon}
                        </IconContext.Provider>
                    )}
                    <Typography variant="link" noWrap>
                        {label}
                    </Typography>
                    {rightIcon && (
                        <IconContext.Provider
                            value={{
                                size: tokens.SizingIconS,
                                weight: 'bold',
                                color: disabled ? tokens.ColorIconDisabled : tokens.ColorIconSubtle,
                            }}
                        >
                            {rightIcon}
                        </IconContext.Provider>
                    )}
                </StyledExportButton>
            </span>
        </Tooltip>
    )
}

const StyledExportButton = styled(ButtonBase)(() => ({
    width: 'fit-content',
    lineHeight: 0,
    height: '32px',
    borderRadius: tokens.SizingCornerS,
    paddingLeft: tokens.SizingSpacing100,
    paddingRight: tokens.SizingSpacing100,
    gap: tokens.SizingSpacing100,
    color: tokens.ColorTextDefault,
    backgroundColor: tokens.ColorSurfaceDefault,
    boxShadow: `inset 0 0 0 ${tokens.SizingBorderS} ${tokens.ColorBorderDefault}`,
    '&:hover': {
        backgroundColor: tokens.ColorSurfaceHover,
        boxShadow: 'none',
    },
    '&:active': {
        backgroundColor: tokens.ColorSurfacePressed,
        boxShadow: 'none',
    },
    '&.Mui-disabled': {
        color: tokens.ColorTextDisabled,
        backgroundColor: tokens.ColorSurfaceDisabled,
        boxShadow: 'none',
    },
})) as typeof ButtonBase
